import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangle } from 'lucide-react';
import { GlassCard, SectionShell } from './LandingPrimitives';

const problems = [
  {
    title: 'Double bookings',
    desc: 'Two teams show up for the same slot — awkward arguments and lost trust.',
  },
  {
    title: 'WhatsApp chaos',
    desc: 'Booking confirmations buried in group chats, impossible to track or audit.',
  },
  {
    title: 'Staff miscommunication',
    desc: 'Ground staff unaware of last-minute changes, leading to no-shows and disputes.',
  },
  {
    title: 'Cash tracking confusion',
    desc: 'No clear record of who paid, how much, and when — money goes missing.',
  },
  {
    title: 'Manual registers',
    desc: 'Paper ledgers take time, get lost, and make end-of-day reconciliation painful.',
  },
  {
    title: 'Revenue leakage',
    desc: 'Underpaid bookings, free slots, and untracked extras quietly drain income.',
  },
];

const ProblemSection = () => {
  return (
    <SectionShell
      id="problems"
      eyebrow="Why Ground Aale"
      title="Built to solve the daily operational mess"
      description="Ground owners shared these recurring pain points. We are designing every feature to remove these bottlenecks."
    >
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {problems.map((item, index) => (
          <motion.div
            key={item.title}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.08 }}
            transition={{ duration: 0.45, delay: index * 0.05 }}
            whileHover={{ y: -4 }}
          >
            <GlassCard className="h-full">
              <div className="flex items-start gap-3">
                <div className="shrink-0 rounded-lg bg-ga-green/20 p-2">
                  <AlertTriangle className="h-4 w-4 text-ga-primary" />
                </div>
                <div>
                  <p className="text-sm font-semibold text-ga-text-primary">{item.title}</p>
                  <p className="mt-1 text-xs text-ga-text-muted leading-relaxed">{item.desc}</p>
                </div>
              </div>
            </GlassCard>
          </motion.div>
        ))}
      </div>
    </SectionShell>
  );
};

export default ProblemSection;
